import ApiService from '@/services/api.service'

const IPFDrgAdjustmentsService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/ipfdrgadjustments/",
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,
            }
          }
          return ApiService.customRequest(requestData);
    },


    Add(data){
        return ApiService.post(`/ipfcomoadjustments`, data);
    },
    Delete(Id){
        return ApiService.delete(`/ipfdrgadjustments/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/ipfdrgadjustments/${Id}`,data);
    },
    Get(Id){
        return ApiService.get(`/ipfdrgadjustments/${Id}`);
    }
  }

  export default IPFDrgAdjustmentsService;
